import type { TFunction } from 'i18next';

const inputOrientationKey = /^input\.orientation\.(\d+)$/;

/** Resolves API instrumentation keys to `instrumentationKeys.*` under `expertToolsJSON.summary.solceller`. */
export function resolveSolarInstrumentationRowLabel(key: string, t: TFunction): string {
  const orientation = inputOrientationKey.exec(key);
  if (orientation) {
    return t('instrumentationKeys.input.orientation', {
      index: orientation[1],
      defaultValue: key
    });
  }
  return t(`instrumentationKeys.${key}`, { defaultValue: key });
}
